import { useState, useEffect } from "react";
import { useAuthContext } from "./useAuthContext";
import { initializeApp, getApps } from "firebase/app";
import { getAuth, getIdToken } from "firebase/auth";
import firebase from "../Firebase";
import Cookies from "js-cookie";

if (!getApps().length) {
  initializeApp(firebase);
}

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [csrfToken, setCsrfToken] = useState(null);
  const { dispatch } = useAuthContext();

  console.log('user login happening')

  // Fetch the CSRF token when the component mounts
  useEffect(() => {
    const fetchCsrfToken = async () => {
      // Fetch the CSRF token from the "mytoken" cookie
      const token = Cookies.get("mytoken");
      setCsrfToken(token);
    };

    fetchCsrfToken();
  }, []);

  const login = async (uid) => {
    setIsLoading(true);
    setError(null);

    console.log("[useLogin] Starting login for uid:", uid);
    console.log("[useLogin] API base URL:", process.env.REACT_APP_API_BASE_URL);

    const body = JSON.stringify({ uid });
    console.log("[useLogin] Request body:", body);

    try {
      // Get the JWT token from Firebase Auth
      const auth = getAuth();
      const token = await getIdToken(auth.currentUser);
      console.log("[useLogin] Got Firebase token:", token ? "✓" : "✗");
      console.log("[useLogin] CSRF token:", csrfToken ? "✓" : "✗");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      // Only add CSRF token if it exists
      if (csrfToken) {
        headers["X-CSRF-Token"] = csrfToken;
      }

      console.log("[useLogin] Request headers:", headers);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/user/login`,
        {
          method: "POST",
          headers: headers,
          body: body,
        }
      );

      console.log("[useLogin] Response status:", response.status);
      console.log("[useLogin] Response headers:", Object.fromEntries(response.headers.entries()));
      
      const json = await response.json();
      console.log("[useLogin] Response data:", json);

      if (!response.ok) {
        setIsLoading(false);
        
        // Handle specific error cases  
        if (response.status === 404) {
          setError("User account not found in database. Please contact support or try signing up again.");
        } else if (response.status === 500) {
          setError(`Server error: ${json.error || 'Internal server error'}`);
        } else {
          setError(`Login failed (${response.status}): ${json.error || json.message || 'Unknown error'}`);
        }
        console.error("[useLogin] Detailed error:", { status: response.status, json });
        return false;
      }

      // save the user to local storage
      console.log("[useLogin] Login successful, saving user data");
      localStorage.setItem("user", JSON.stringify(json));

      // update the auth context
      dispatch({ type: "LOGIN", payload: json });

      // update loading state
      setIsLoading(false);

      return true;
    } catch (error) {
      console.error("[useLogin] Network/fetch error:", error);
      setIsLoading(false);
      setError("Network error. Please check your connection and try again.");
      return false;
    }
  };

  return { login, error, isLoading };
};
